<div *ngIf="(isAuthorized | async); then activeBlock; else disabledBlock"></div>
<ng-template #activeBlock>
    <a class="navbar-item" [routerLink]="navbarItem.link" [ngClass]="(isActive | async) ? 'active' : ''"
        [title]="navbarItem.text" (click)="onClick()">
        <div class="navbar-item">
            <div class="menu">
                <i class="fa-2x fa-fw" [ngClass]="navbarItem.icon" aria-hidden="true">
                    <!-- <aa-warning-badge [warningBadgeValue]="value"></aa-warning-badge> -->
                </i>
                <p class="text">{{ navbarItem.text }}</p>
            </div>

            <div class="new-ribbon" *ngIf="navbarItem.soon">
                {{ "LAYOUT.MENU.RIBBON.SOON" | translate }}
            </div>
            <div class="new-ribbon" *ngIf="navbarItem.nuovo">
                {{ "LAYOUT.MENU.RIBBON.NUOVO" | translate }}
            </div>
        </div>
    </a>
</ng-template>
<ng-template #disabledBlock>
    <div class="navbar-item disabled">
        <div class="menu">
            <i class="fa-2x fa-fw" [ngClass]="navbarItem.icon" aria-hidden="true"></i>
            <p class="text">{{ navbarItem.text }}</p>
        </div>
        <div class="new-ribbon" *ngIf="navbarItem.soon">
            {{ "LAYOUT.MENU.RIBBON.SOON" | translate }}
        </div>
        <div class="new-ribbon" *ngIf="navbarItem.nuovo">
            {{ "LAYOUT.MENU.RIBBON.NUOVO" | translate }}
        </div>
    </div>
</ng-template>